module.exports = __webpack_public_path__ + "img/services@2x.ddf3c885.png";